import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, isRef as _isRef, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/touxiang.jpg'
import _imports_1 from '@/assets/images/enlarge.png'
import _imports_2 from '@/assets/images/imgReplace.png'
import _imports_3 from '@/assets/images/titleDel.png'


const _withScopeId = n => (_pushScopeId("data-v-76d5ca36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"user-select":"none"} }
const _hoisted_2 = {
  key: 0,
  class: "mod_c"
}
const _hoisted_3 = {
  key: 0,
  class: "mod_c_title"
}
const _hoisted_4 = { class: "mod_c_tbody select_none" }
const _hoisted_5 = { class: "container_textLeft" }
const _hoisted_6 = { class: "establish_btn" }
const _hoisted_7 = { class: "setup_text" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "portal_name" }, "门户名称:", -1))
const _hoisted_9 = { class: "nick_input" }
const _hoisted_10 = { class: "text_number" }
const _hoisted_11 = { class: "display_time" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "portal_name" }, "展示时间:", -1))
const _hoisted_13 = { class: "nick_input" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_space" }, "至", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mask_tip" }, "未设置结束时间，默认为永久有效。", -1))
const _hoisted_16 = { class: "delete_btn" }
const _hoisted_17 = { class: "establish_table" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mask_tip" }, "内容管理", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mask_tip" }, "装修", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mask_tip" }, "推广", -1))
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mask_tip" }, "删除", -1))
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "mod_pagin establish_pagation" }
const _hoisted_25 = { class: "Portal_promotion flex between" }
const _hoisted_26 = { class: "right_box" }
const _hoisted_27 = { class: "portal_right" }
const _hoisted_28 = { class: "right_top flex between" }
const _hoisted_29 = { class: "echart_people" }
const _hoisted_30 = { class: "right_content flex between" }
const _hoisted_31 = { class: "content_qr" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "content_text" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "建议尺寸：62px * 62px", -1))
const _hoisted_35 = { class: "content_link flex between" }
const _hoisted_36 = {
  class: "link_input",
  id: "warrants"
}
const _hoisted_37 = ["data-clipboard-text"]
const _hoisted_38 = { class: "wechat_box" }
const _hoisted_39 = { class: "wechat_content" }
const _hoisted_40 = { class: "wechat_text flex between" }
const _hoisted_41 = { class: "text_article between" }
const _hoisted_42 = { class: "article_label" }
const _hoisted_43 = { class: "label_title" }
const _hoisted_44 = { class: "label_content flex between" }
const _hoisted_45 = { class: "text" }
const _hoisted_46 = { class: "imges" }
const _hoisted_47 = ["src"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "article_img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "编辑", -1))
const _hoisted_50 = { class: "edit_box" }
const _hoisted_51 = { class: "edit_content" }
const _hoisted_52 = { class: "edit_title flex keep" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "标题:", -1))
const _hoisted_54 = { class: "edit_descript keep" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "描述:", -1))
const _hoisted_56 = { class: "text_number" }
const _hoisted_57 = { class: "edit_descript keep" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title thumbnail" }, "缩略图:", -1))
const _hoisted_59 = { class: "edit_upload flex" }
const _hoisted_60 = ["src"]
const _hoisted_61 = { key: 1 }
const _hoisted_62 = { class: "edit_look" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "look_icon",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_64 = { class: "upload_tip" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip_txt" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "keep" }, "支持格式：jpg, png, gif, 3M以内"),
  /*#__PURE__*/_createElementVNode("p", null, "建议尺寸：1920*1080px")
], -1))
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = { class: "upload_tips" }
const _hoisted_68 = { class: "head keep" }
const _hoisted_69 = { class: "size keep" }
const _hoisted_70 = { class: "icon flex" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "replace",
  src: _imports_2,
  alt: ""
}, null, -1))

import Crumb from '@/components/Crumb.vue';
import { reactive, ref, watch } from 'vue';
import { ColumnProps } from 'ant-design-vue/es/table/interface';
import { LoadingOutlined, SearchOutlined } from '@ant-design/icons-vue';
import CDelModal from '@/components/CDelModal.vue';
import http from '@/api/conentCenter/communal';
import { useRoute } from 'vue-router';
import ClipboardJS from 'clipboard';
import { getToken } from '@/plugins/cookie';
import { uploadNow } from '../components/PublicFunction';
import { FileItem, FileInfo } from '../components/types';
type Key = ColumnProps['key'];
interface DataType {
  key: number;
  name: string;
  created_at: string;
  show: number;
}

interface lives {
  share_url: string;
  qr_code: string;
  share_title: string;
  share_content: string;
  logo_image: string;
  logoId: number;
  promotion: string;
  cover: string;
  portal_id: string;
  share_qr_code: string;
  uploadName: string;
  uploadSize: number;
  preview_img: string;
}

const __default__ = { name: '' };
import moment, { Moment } from 'moment';
import { Input, Modal, Pagination, Table, Switch, Popover, message, Upload, DatePicker, Space, Image } from 'ant-design-vue';
import { QuestionCircleFilled } from '@ant-design/icons-vue';
import AppLink from '@/components/AppLink.vue';
import recycleBin from './recycleBin.vue';
const aInputSearch = Input.Search;
const { RangePicker } = DatePicker;
const aRangePicker = RangePicker;
const aPagination = Pagination;
const aTable = Table;
const aUpload = Upload;
const aImage = Image;
const aPopover = Popover;
const aSpace = Space;
const aDatePicker = DatePicker;
const aSwitch = Switch;
const aModal = Modal;
const ranges: any = {
  今天: [moment().startOf('day'), moment().endOf('day')],
  最近一周: [moment().startOf('day').subtract(1, 'weeks'), moment()],
  最近一月: [moment().startOf('day').subtract(1, 'months'), moment()],
  最近三月: [moment().startOf('day').subtract(3, 'months'), moment()],
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();
const gatewayId = route.params.gatewayId;
const estabVisible = ref(false);
const modalVisible = ref(false);
const portalName = ref('');
const tabs = ref(0);
const showLoading = ref<boolean>(false);
const mediaRef = ref();
const createGift = ref(true);
//  创建列表按钮
const setUp = () => {
  estabVisible.value = true;
};
//创建列表取消按钮
const cancel = () => {
  estabVisible.value = false;
};
//创建列表确认按钮
const disabledDate = (current: Moment) => {
  return current < moment().endOf('day').subtract(1, 'days');
};
let obj = ref({
  createStar: 0,
  createEnd: 0,
});
const keep = () => {
  estabVisible.value = false;
  // 转时间戳
  let start: number = Math.floor(Number(new Date(obj.value.createStar).getTime() / 1000));
  let end: number = Math.floor(Number(new Date(obj.value.createEnd).getTime() / 1000));
  let create = {
    name: portalName.value,
    start_at: start,
    end_at: end,
    portal_id: gatewayId,
  };
  http
    .getCreatePortal(create)
    .then((res) => {
      if (res.data.code == 200) {
        portalList();
        message.destroy();
        message.success(res.data.message);
      }
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
};
//删除按钮
const estabDelete = () => {
  createGift.value = false;
};
//弹框删除按钮
const openDelModat = () => {
  modalVisible.value = false;
  selectedRowKeys.value = [];
};
////弹框确认按钮
const removeLiveData = () => {
  modalVisible.value = false;
  let del = {
    portal_id: portalId.value,
  };
  http.getDelPortal({ params: del }).then((res) => {
    portalList();
    message.destroy();
    message.success('删除成功！');
  });
};

const selectedRowKeys = ref<Key[]>([]);
selectedRowKeys.value = [];

//表格ok按钮
const hideModal = () => {
  estabVisible.value = true;
};
//表格删除按钮
const portalId = ref();
const tabDel = (record: any) => {
  selectedRowKeys.value = [];
  selectedRowKeys.value.push(record.id);
  modalVisible.value = true;
  portalId.value = record.portal_id; //获取列表portal_id
};

// 分页
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 12, // 每页条数
  totalSize: 0, // 总数
  options: ['12', '24', '36', '48', '60'], // 选项
});
//表格头
const columns = [
  {
    title: '门户名称',
    dataIndex: 'name',
    width: '35%',
    align: 'left',
  },
  {
    title: '启用开关',
    dataIndex: 'show',
    width: '20%',
    slots: {
      customRender: 'show',
    },
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    width: '20%',
    align: 'center',
  },
  {
    title: '操作',
    dataIndex: 'portalHandle',
    width: '35%',
    align: 'center',
    slots: {
      customRender: 'portalHandle',
    },
  },
];
//表格数据
const datafol = ref<DataType[]>([]);
const operation = reactive({
  use_time_filter: ref([]), // 使用记录时间筛选
  inputSearch: '',
});
// 门户列表
const portalList = () => {
  showLoading.value = true;
  let portal = {
    keyword: operation.inputSearch,
    start_at: operation.use_time_filter[0] ? new Date(operation.use_time_filter[0]) : operation.use_time_filter[0],
    end_at: operation.use_time_filter[1] ? new Date(operation.use_time_filter[1]) : operation.use_time_filter[1],
    page: pageConfig.current,
    page_num: pageConfig.pageSize,
  };
  http
    .getPortalList({ params: portal })
    .then((res) => {
      pageConfig.current = res.data.data.current_page;
      pageConfig.totalSize = res.data.data.total;
      const degree = res.data.data;
      datafol.value = [...degree.data];
      if (res.data.code == 200) {
        showLoading.value = false;
      }
    })
    .catch((res) => {
      showLoading.value = false;
      message.destroy();
      message.error(res.data.error);
    });
  selectedRowKeys.value = [];
};
portalList();
// 设置门户显示开关
const setPortalShow = (item: any) => {
  message.destroy();
  let setPortal = {
    id: item.id,
    show: item.show,
    portal_id: item.portal_id,
  };
  http
    .getSetPortalShow({ params: setPortal })
    .then((res) => {
      portalList();
      message.success(res.data.message);
    })
    .catch((res) => {
      item.show = !item.show;
      message.error(res.data.error);
    });
};

// 门户推广
const confirm = ref(false);

const saveAddFile = () => {
  confirm.value = false;
  let portalShare = {
    portal_id: liveData.value.portal_id,
    share_title: liveData.value.share_title,
    share_content: liveData.value.share_content,
    share_qr_code: liveData.value.share_qr_code,
    logo_image: liveData.value.logo_image,
    cover: liveData.value.cover,
  };
  http
    .getsetPortalShare(portalShare)
    .then((res) => {
      message.success(res.data.message);
    })
    .then((res: any) => {
      message.error(res.data.error);
    });
};
const getTabs = (id: number) => {
  tabs.value = id;
};
const liveData = ref<lives>({
  share_url: '',
  qr_code: '',
  share_title: '',
  share_content: '',
  logo_image: '',
  logoId: 0,
  promotion: '',
  cover: '',
  portal_id: '',
  share_qr_code: '',
  uploadName: '',
  uploadSize: 0,
  preview_img: '',
});
// 下载二维码
const downs = () => {
  window.location.href = liveData.value.qr_code;
};
// 获取门户推广信息
const prtalExtensionInfo = (item: any) => {
  confirm.value = true;
  let extension = {
    portal_id: item.portal_id,
  };
  http.getPortalExtensionInfo({ params: extension }).then((res) => {
    const exten = res.data.data;
    liveData.value = res.data.data;
  });
};
// 复制
const Copylist = (btns: string) => {
  let ClipboardJSObj = new ClipboardJS(btns);
  ClipboardJSObj.on('success', function (e) {
    message.destroy();
    message.info('复制成功');
    e.clearSelection();
  });
  ClipboardJSObj.on('error', function () {
    message.destroy();
    message.info('复制失败');
  });
};

// 打开前端门户
const openGateway = (data: any) => {
  window.open(data.share_url, '_blank');
};

// 标题弹框
const titleConfirm = ref(false);
const token = getToken();
const shows = ref(false);

const editHead = () => {
  confirm.value = false;
  titleConfirm.value = true;
};
// 推广保存
// 防抖
const shake = ref<boolean>(false);
const saveEditFile = () => {
  titleConfirm.value = false;
  let portalShare = {
    portal_id: liveData.value.portal_id,
    share_title: liveData.value.share_title,
    share_content: liveData.value.share_content,
    share_qr_code: liveData.value.share_qr_code,
    logo_image: liveData.value.logo_image,
    cover: liveData.value.cover,
  };
  if (shake.value) {
    return;
  }
  shake.value = true;
  http
    .getsetPortalShare(portalShare)
    .then((res) => {
      shake.value = false;
      message.success(res.data.message);
    })
    .catch((res) => {
      message.error(res.data.error);
    });
};

const { file, fileList, flieLink, loading, beforeUpload, handleChange } = uploadNow();
watch(
  () => flieLink.value,
  () => {
    liveData.value.cover = flieLink.value;
    liveData.value.uploadName = file.value.name;
    liveData.value.uploadSize = file.value.size;
  }
);
watch(
  () => loading.value,
  () => {
    if (loading.value == true) {
      shows.value = false;
    } else {
      shows.value = true;
    }
  }
);
const titleDel = () => {
  liveData.value.cover = '';
  liveData.value.uploadName = '';
  liveData.value.uploadSize = 0;
  shows.value = false;
};

const uploadIcon = (info: FileInfo) => {
  if (info.file?.response?.code === 200) {
    liveData.value.logo_image = info.file?.response?.data.url;
    liveData.value.logoId = info.file?.response ? info.file?.response?.data.id : 0;
    promotionQrCode();
  }
  if (info.file?.response?.code === 100) {
    console.log(info.file?.response);
    message.error(info.file?.response?.error);
  }
  if (info.file.status === 'uploading') {
    loading.value = true;
  } else {
    loading.value = false;
  }
};
// 获取推广二维码  上传图标
const pullImg = ref();
const promotionQrCode = () => {
  let promoto = {
    portal_id: liveData.value.portal_id,
    logo_image: liveData.value.logo_image,
  };
  http
    .getPromotionQrCode({ params: promoto })
    .then((res) => {
      const target = res.data.data;
      pullImg.value = target;
      liveData.value.qr_code = '';
      liveData.value.qr_code = target;
    })
    .catch((res) => {
      message.error(res.data.error);
    });
};

const getCreateStatus = (data: any) => {
  createGift.value = data;
  portalList();
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Crumb),
    _createElementVNode("div", {
      class: "mod_wrap",
      ref_key: "mediaRef",
      ref: mediaRef
    }, [
      (createGift.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (!_unref(route).meta.hidden)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(route).meta?.title), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(aRangePicker), {
                    value: operation.use_time_filter,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((operation.use_time_filter) = $event)),
                    ranges: ranges,
                    "show-time": { format: 'HH:mm' },
                    format: "YYYY-MM-DD HH:mm",
                    class: "mod_range_picker container_textLeft_picker",
                    onChange: portalList
                  }, {
                    suffixIcon: _withCtx(() => [
                      _createVNode(_component_svg_icon, { "icon-class": "icon_time" })
                    ]),
                    _: 1
                  }, 8, ["value"]),
                  _createVNode(_unref(aInputSearch), {
                    class: "mod_range_picker_search",
                    value: operation.inputSearch,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((operation.inputSearch) = $event)),
                    placeholder: "请输入门户名称",
                    onSearch: portalList
                  }, {
                    enterButton: _withCtx(() => [
                      _createVNode(_unref(SearchOutlined))
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_a_button, {
                    class: "establish_button",
                    onClick: setUp
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("创建")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_button, {
                    class: "establish_del",
                    onClick: estabDelete
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("回收站")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createVNode(_unref(aModal), {
                visible: estabVisible.value,
                "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((estabVisible).value = $event)),
                title: "门户创建",
                onOk: hideModal,
                closable: true,
                class: "official_config",
                footer: null,
                centered: "",
                width: "690px"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_a_input, {
                        value: portalName.value,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((portalName).value = $event)),
                        class: "area_tex",
                        "show-count": "",
                        maxlength: 80,
                        placeholder: "请输入内容"
                      }, {
                        suffix: _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, _toDisplayString(portalName.value.length) + "/80", 1)
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_unref(aSpace), { direction: "vertical" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(aDatePicker), {
                            "show-time": { format: 'HH:mm:ss' },
                            format: "YYYY-MM-DD HH:mm:ss",
                            placeholder: "开始时间",
                            modelValue: _unref(obj).createStar,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(obj).createStar) = $event)),
                            "disabled-date": disabledDate,
                            class: "mod_range_picker container_textLeft_picker"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _hoisted_14,
                      _createVNode(_unref(aSpace), { direction: "vertical" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(aDatePicker), {
                            "show-time": { format: 'HH:mm:ss' },
                            format: "YYYY-MM-DD HH:mm:ss",
                            placeholder: "结束时间",
                            modelValue: _unref(obj).createEnd,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(obj).createEnd) = $event)),
                            class: "mod_range_picker container_textLeft_picker"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_unref(aPopover), { placement: "top" }, {
                      content: _withCtx(() => [
                        _hoisted_15
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(QuestionCircleFilled), { class: "QuestionCircleFilled" })
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_a_button, {
                      class: "mod_modal_btn",
                      onClick: cancel
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("取消")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, {
                      class: "mod_modal_btn mod_type_primary",
                      onClick: keep
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("确定")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["visible"]),
              _createVNode(CDelModal, {
                visible: modalVisible.value,
                centered: "",
                close: openDelModat,
                ok: removeLiveData
              }, null, 8, ["visible"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_unref(aTable), {
                loading: showLoading.value,
                columns: columns,
                "data-source": datafol.value,
                pagination: false,
                class: "liveList_w",
                rowKey: 
          (res) => {
            return res.id;
          }
        
              }, {
                show: _withCtx(({ record }) => [
                  _createVNode(_unref(aSwitch), {
                    checked: record.show,
                    "onUpdate:checked": ($event: any) => ((record.show) = $event),
                    onChange: ($event: any) => (setPortalShow(record)),
                    "checked-value": 1,
                    "un-checked-value": 0
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(record.text), 1)
                    ]),
                    _: 2
                  }, 1032, ["checked", "onUpdate:checked", "onChange"])
                ]),
                portalHandle: _withCtx(({ record }) => [
                  _createVNode(_unref(aPopover), {
                    placement: "left",
                    "arrow-point-at-center": ""
                  }, {
                    content: _withCtx(() => [
                      _hoisted_18
                    ]),
                    default: _withCtx(() => [
                      _createVNode(AppLink, {
                        to: `/site/article/${record.portal_id}`,
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_svg_icon, {
                            class: "liveList_out",
                            "icon-class": "curation"
                          }),
                          _createTextVNode(" " + _toDisplayString(record.text), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(aPopover), {
                    placement: "left",
                    "arrow-point-at-center": ""
                  }, {
                    content: _withCtx(() => [
                      _hoisted_19
                    ]),
                    default: _withCtx(() => [
                      _createVNode(AppLink, {
                        to: `/site/decorate/${record.portal_id}`,
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_svg_icon, {
                            class: "liveList_out",
                            "icon-class": "union"
                          }),
                          _createTextVNode(" " + _toDisplayString(record.text), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(aPopover), {
                    placement: "left",
                    "arrow-point-at-center": ""
                  }, {
                    content: _withCtx(() => [
                      _hoisted_20
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        centered: "",
                        onClick: ($event: any) => (prtalExtensionInfo(record))
                      }, [
                        _createVNode(_component_svg_icon, {
                          class: "liveList_out",
                          "icon-class": "unionPush"
                        }),
                        _createTextVNode(" " + _toDisplayString(record.text), 1)
                      ], 8, _hoisted_21)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(aPopover), {
                    placement: "left",
                    "arrow-point-at-center": ""
                  }, {
                    content: _withCtx(() => [
                      _hoisted_22
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        centered: "",
                        onClick: ($event: any) => (tabDel(record))
                      }, [
                        _createVNode(_component_svg_icon, { "icon-class": "unionDel" }),
                        _createTextVNode(" " + _toDisplayString(record.text), 1)
                      ], 8, _hoisted_23)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["loading", "data-source", "rowKey"])
            ]),
            _createElementVNode("div", _hoisted_24, [
              (datafol.value.length !== 0)
                ? (_openBlock(), _createBlock(_unref(aPagination), {
                    key: 0,
                    "show-quick-jumper": "",
                    total: pageConfig.totalSize,
                    current: pageConfig.current,
                    "onUpdate:current": _cache[6] || (_cache[6] = ($event: any) => ((pageConfig.current) = $event)),
                    "page-size": pageConfig.pageSize,
                    "onUpdate:pageSize": _cache[7] || (_cache[7] = ($event: any) => ((pageConfig.pageSize) = $event)),
                    pageSizeOptions: pageConfig.options,
                    "show-less-items": "",
                    "show-size-changer": "",
                    onChange: portalList,
                    onShowSizeChange: portalList
                  }, null, 8, ["total", "current", "page-size", "pageSizeOptions"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_unref(aModal), {
              visible: confirm.value,
              "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((confirm).value = $event)),
              title: "门户推广",
              centered: "",
              onOk: saveAddFile,
              okText: "确定",
              width: "660px"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["qr_share flex", tabs.value == 0 ? 'tabs_radios' : '']),
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (getTabs(0)))
                        }, "二维码分享", 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["wechat_share flex", tabs.value == 1 ? 'tabs_radios' : '']),
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (getTabs(1)))
                        }, "微信分享", 2)
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            (liveData.value.qr_code)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: liveData.value.qr_code,
                                  alt: ""
                                }, null, 8, _hoisted_32))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            _createVNode(_unref(aUpload), {
                              "file-list": _unref(fileList),
                              "onUpdate:fileList": _cache[10] || (_cache[10] = ($event: any) => (_isRef(fileList) ? (fileList).value = $event : null)),
                              name: "images",
                              multiple: true,
                              showUploadList: false,
                              action: "/api/v1/common/upload_images",
                              accept: ".jpg,.jpeg,.svg,.png,.gif",
                              headers: {
                          token: _unref(token),
                        },
                              onChange: uploadIcon
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, { class: "text_upload" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("上传图标")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["file-list", "headers"]),
                            _hoisted_34,
                            _createVNode(_component_a_button, {
                              class: "down_qr",
                              onClick: downs
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("下载二维码")
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, _toDisplayString(liveData.value.share_url), 1),
                          _createElementVNode("div", {
                            class: "repeat_btn warrant",
                            "data-clipboard-text": liveData.value.share_url,
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (Copylist('.warrant')))
                          }, [
                            _createVNode(_component_a_button, { class: "clone" }, {
                              default: _withCtx(() => [
                                _createTextVNode("复制")
                              ]),
                              _: 1
                            })
                          ], 8, _hoisted_37),
                          _createVNode(_component_a_button, {
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (openGateway(liveData.value)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("打开")
                            ]),
                            _: 1
                          })
                        ])
                      ], 512), [
                        [_vShow, tabs.value === 0]
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, [
                                _createElementVNode("div", _hoisted_43, _toDisplayString(liveData.value.share_title), 1),
                                _createElementVNode("div", _hoisted_44, [
                                  _createElementVNode("div", _hoisted_45, _toDisplayString(liveData.value.share_content), 1),
                                  _createElementVNode("div", _hoisted_46, [
                                    _createElementVNode("img", {
                                      src: liveData.value.cover,
                                      alt: ""
                                    }, null, 8, _hoisted_47)
                                  ])
                                ])
                              ]),
                              _hoisted_48
                            ]),
                            _createElementVNode("div", {
                              class: "text_edit cursor",
                              onClick: editHead
                            }, [
                              _createVNode(_component_svg_icon, {
                                "icon-class": "editIcon",
                                class: "edit"
                              }),
                              _hoisted_49
                            ])
                          ])
                        ])
                      ], 512), [
                        [_vShow, tabs.value === 1]
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["visible"]),
            _createVNode(_unref(aModal), {
              visible: titleConfirm.value,
              "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => ((titleConfirm).value = $event)),
              title: "分享设置",
              centered: "",
              onOk: saveEditFile,
              okText: "确定",
              width: "564px"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _hoisted_53,
                      _createVNode(_component_a_input, {
                        class: "input keep",
                        value: liveData.value.share_title,
                        "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((liveData.value.share_title) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _hoisted_55,
                      _createVNode(_component_a_input, {
                        value: liveData.value.share_content,
                        "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((liveData.value.share_content) = $event)),
                        class: "area_tex",
                        "show-count": "",
                        maxlength: 50,
                        placeholder: "点进来看看"
                      }, {
                        suffix: _withCtx(() => [
                          _createElementVNode("div", _hoisted_56, _toDisplayString(liveData.value.share_content.length) + "/50", 1)
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _hoisted_58,
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", null, [
                          _createVNode(_unref(aUpload), {
                            "file-list": _unref(fileList),
                            "onUpdate:fileList": _cache[16] || (_cache[16] = ($event: any) => (_isRef(fileList) ? (fileList).value = $event : null)),
                            name: "images",
                            "list-type": "picture-card",
                            class: "avatar_uploader",
                            accept: ".jpg,.jpeg,.png,.gif",
                            "show-upload-list": false,
                            action: "/api/v1/common/upload_images",
                            "before-upload": _unref(beforeUpload),
                            headers: {
                        token: _unref(token),
                      },
                            onChange: _unref(handleChange)
                          }, {
                            default: _withCtx(() => [
                              (liveData.value.cover)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: liveData.value.cover,
                                    alt: "avatar",
                                    class: "images"
                                  }, null, 8, _hoisted_60))
                                : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                    (_unref(loading))
                                      ? (_openBlock(), _createBlock(_unref(LoadingOutlined), { key: 0 }))
                                      : (_openBlock(), _createBlock(_component_svg_icon, {
                                          key: 1,
                                          class: "cover_img",
                                          "icon-class": "coverImgs"
                                        }))
                                  ]))
                            ]),
                            _: 1
                          }, 8, ["file-list", "before-upload", "headers", "onChange"]),
                          _withDirectives(_createElementVNode("div", _hoisted_62, [
                            _createVNode(_unref(aImage), {
                              width: 14,
                              src: liveData.value.cover
                            }, null, 8, ["src"]),
                            _hoisted_63
                          ], 512), [
                            [_vShow, shows.value]
                          ])
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_64, _hoisted_66, 512), [
                          [_vShow, !shows.value]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_67, [
                          _createElementVNode("div", _hoisted_68, _toDisplayString(liveData.value.uploadName), 1),
                          _createElementVNode("div", _hoisted_69, "文件大小:" + _toDisplayString((liveData.value.uploadSize / (1024 * 1024)).toFixed(2)) + "M", 1),
                          _createElementVNode("div", _hoisted_70, [
                            _createVNode(_unref(aUpload), {
                              "file-list": _unref(fileList),
                              "onUpdate:fileList": _cache[17] || (_cache[17] = ($event: any) => (_isRef(fileList) ? (fileList).value = $event : null)),
                              name: "images",
                              multiple: true,
                              action: "/api/v1/common/upload_images",
                              headers: {
                          token: _unref(token),
                        },
                              "before-upload": _unref(beforeUpload),
                              accept: ".jpg,.png,.gif",
                              onChange: _unref(handleChange),
                              "show-upload-list": false
                            }, {
                              default: _withCtx(() => [
                                _hoisted_71
                              ]),
                              _: 1
                            }, 8, ["file-list", "headers", "before-upload", "onChange"]),
                            _createElementVNode("img", {
                              src: _imports_3,
                              alt: "",
                              onClick: titleDel
                            })
                          ])
                        ], 512), [
                          [_vShow, shows.value]
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["visible"])
          ]))
        : (_openBlock(), _createBlock(recycleBin, {
            key: 1,
            onCreateStatus: getCreateStatus
          }))
    ], 512)
  ]))
}
}

})